<template>
  <main :class="`modal modal-${size || 'sm'} ` + 'active'" v-if="active" id="modal-id">
    <a @click.prevent="close()" class="modal-overlay" aria-label="Close"></a>
    <div class="modal-container" :style="css">
      <div class="modal-header" :style="heading">
        <a @click.prevent="close()" class="btn btn-clear float-right" aria-label="Close"></a>
        <div class="modal-title h5">{{title}}</div>
      </div>
      <div class="modal-body">
        <div class="content" v-html="body">
        </div>
      </div>
      <div v-if="btn" class="modal-footer"  style="text-align: left !important">
        <button :class="btn.class" @click.prevent="setAction()" class="btn">{{btn.text || 'fechar'}}</button>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  props: [
    'body',
    'css',
    'title',
    'active',
    'size',
    'action',
    'btn',
    'heading'
  ],
  methods: {
    close () {
      this.$emit('close', true)
      // this.$router.push('/doctor/user/offices')
    },
    setAction () {
      this.action()
    }
  }
}
</script>
